"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-custom-scrollbars/lib/utils/returnFalse.js
// module id = ./node_modules/react-custom-scrollbars/lib/utils/returnFalse.js
// module chunks = main